import { createSelector } from 'reselect';
import { TICKET_ENTITY_TYPE } from '../../common/constants/VelarisSupportConstants';
import { daysDiff } from '../../common/util/commonUtil';

export const allParticipantsFromState = (state) =>
  state.velarisSupport.participants.data.requesters;

export const allTicketsFromState = (state) =>
  state.velarisSupport.tickets.data.tickets;

export const ticketParticipantsSelector = createSelector(
  allParticipantsFromState,
  (participants) => participants
);

export const ticketDetailsSelector = createSelector(
  allParticipantsFromState,
  (participants) => participants
);

export const selectedTicketFromState = (state) =>
  state.velarisSupport.activeTicket.data;

export const selectedTicketId = (state) =>
  state.velarisSupport.activeTicket.data.ticketId;

const ticketSummary = (state) => state.tickets.ticketSummary;
const ticketV2Summary = (state) => state.velarisSupport.ticketSummary.data;

export const linkedEntitiesSelector = createSelector(
  selectedTicketFromState,
  ({ entities }) => {
    return (entities || []).reduce(
      (acc, { id, type }) => {
        if (type === TICKET_ENTITY_TYPE.ORGANIZATION) {
          acc.organizations.push(id);
        } else if (type === TICKET_ENTITY_TYPE.ACCOUNT) {
          acc.accounts.push(id);
        }
        return acc;
      },
      { organizations: [], accounts: [] }
    );
  }
);

export const ticketSummarySelector = createSelector(
  ticketSummary,
  ticketV2Summary,
  (summary, v2Summary) => {
    return Object.keys(v2Summary).reduce((tsAcc, group) => {
      tsAcc[group] = Object.keys(v2Summary[group]).reduce((gAcc, val) => {
        gAcc[val] =
          v2Summary[group][val] + (summary[group]?.[val.toLowerCase()] || 0);
        return gAcc;
      }, {});
      return tsAcc;
    }, {});
  }
);

export const ticketActivitySelector = createSelector(
  (state) => state.velarisSupport.ticketActivity.data.history,
  (state) => state.velarisSupport.activeTicket.data.created,
  (activity, ticketCreated) => {
    let prevDays = null;
    return Object.keys(activity || []).map((key) => {
      const daysSinceCreated = daysDiff(ticketCreated, key);
      let daysLabel = null;
      if (prevDays !== daysSinceCreated) {
        prevDays = daysSinceCreated;
        daysLabel = `+ ${daysSinceCreated} days`;
      }
      return {
        dateTime: key,
        events: activity[key],
        daysLabel,
      };
    });
  }
);
